/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum NoteTopic {
    None = '0',
    Message = 1,
    Email = 2,
    States = 4,
    All = -1,
}
